import styled, { withTheme } from 'styled-components';
import bp from '@bootstrap-styled/css-mixins/lib/breakpoints';

const SelectProductCheckboxContainer = styled.div.attrs(() => (
    {
        className: 'select-product-checkbox-container',
    }
))`
    .select-product-checkboxes {
        display: flex;
        height:100%;
        align-items: center;
        justify-content: flex-start;
        flex-direction: row;
        ${props => bp.down('md', props.theme['$grid-breakpoints'], `
            align-items: center;
            flex-direction: column;
        `)}

        .select-product-checkbox {
            height:100%;
            width:100%;
            flex:1;
            padding:0;
            &.oceanblue {
                .checkbox-body {
                    input[type=checkbox]:checked + label,  input[type=checkbox] + label:hover, input[type=checkbox]:checked + label:hover {
                        background: ${(props) => props.theme.$oceanblue};
                        .label {
                            color: ${(props) => props.theme.$white};
                        }
                    }
                }
            }
            &.blue {
                .checkbox-body {
                    input[type=checkbox]:checked + label,  input[type=checkbox] + label:hover, input[type=checkbox]:checked + label:hover {
                        background: ${(props) => props.theme.$blue};
                        .label {
                            color: ${(props) => props.theme.$white};
                        }
                    }
                }
            }
            &.maroon {
                .checkbox-body {
                    input[type=checkbox]:checked + label,  input[type=checkbox] + label:hover, input[type=checkbox]:checked + label:hover {
                        background: ${(props) => props.theme.$maroon};
                        .label {
                            color: ${(props) => props.theme.$white};
                        }
                    }
                }
            }
            &.pink {
                .checkbox-body {
                    input[type=checkbox]:checked + label,  input[type=checkbox] + label:hover, input[type=checkbox]:checked + label:hover {
                        background: ${(props) => props.theme.$pink};
                        .label {
                            color: ${(props) => props.theme.$white};
                        }
                    }
                }
            }
            &.green {
                .checkbox-body {
                    input[type=checkbox]:checked + label,  input[type=checkbox] + label:hover, input[type=checkbox]:checked + label:hover {
                        background: ${(props) => props.theme.$green};
                        .label {
                            color: ${(props) => props.theme.$white};
                        }
                    }
                }
            }
            &.purple {
                .checkbox-body {
                    input[type=checkbox]:checked + label,  input[type=checkbox] + label:hover, input[type=checkbox]:checked + label:hover {
                        background: ${(props) => props.theme.$purple};
                        .label {
                            color: ${(props) => props.theme.$white};
                        }
                    }
                }
            }
            .checkbox-body {
                width:100%;
                height:100%;
                position:relative;
                input[type=checkbox] {
                    opacity:0;
                    position:absolute;
                    left:-999px;
                }
                input[type=checkbox] + label, input[type=checkbox]:focus + label {
                    display:block;
                    height:100%;
                    width:100%;
                    margin:0 !important;
                    cursor: pointer;
                    padding:14px;
                    border: 1px solid ${(props) => props.theme.$gold};
                    ${(props) => bp.down('md', props.theme['$grid-breakpoints'], `
                        border-bottom:none;
                    `)}
                    ${(props) => bp.up('lg', props.theme['$grid-breakpoints'], `
                        border-right:none;
                    `)}
                    background: transparent;
                    text-align:center;
                    .title {
                        color: ${(props) => props.theme.$gold};
                        font-size: ${(props) => props.theme['$font-size-14']};
                        font-family: ${(props) => props.theme['$font-family-sans-serif']} !important;
                        font-weight: 500 !important;
                        display:block;
                        margin:0 0 10px 0;
                        text-transform: uppercase;
                    }
                    .label {
                        font-family: ${(props) => props.theme['$font-family-sans-serif']} !important;
                        font-weight: 400 !important;
                        text-transform: uppercase;
                        color: ${(props) => props.theme.$gold};
                        font-size: ${(props) => props.theme['$font-size-16']};
                        display:block;
                        margin:0 0 15px 0;
                    }
            
                }
                input[type=checkbox]:checked + label, input[type=checkbox]:checked + label:hover {
                    padding:15px;
                    border: 0 !important;
                }
            }
            &:last-child {
                input[type=checkbox] + label, input[type=checkbox]:focus + label {
                    border-right: 1px solid ${(props) => props.theme.$gold};
                    border-bottom: 1px solid ${(props) => props.theme.$gold};
                }
            }
        }

    }


`;

export default withTheme(SelectProductCheckboxContainer);
